import { AddChangeLogEntryFormData, EditChangeLogEntryFormData } from '../../entities/ChangeLog/ChangeLog'
import { sortChangeLogEntriesByVersionDescending } from '../../entities/ChangeLog/ChangeLogHelpers'
import {
    deleteChangeLogEntryApiCall,
    patchChangeLogEntryApiCall,
    postChangeLogEntryApiCall,
} from '../../entities/ChangeLog/ChangeLogService'
import { isFetchResultSuccessful } from '../../entities/FetchResult'
import { setChangeLogEntries } from '../changeLogEntries/changeLogEntriesReducer'
import { Reducers } from '../reducers'
import { TypedDispatch } from '../store'
import {
    setChangeLogEntryToExistingChangeLogEntries,
    setError,
    setIsLoading,
    setIsSuccessful,
} from './changeLogEntryReducer'

export const addChangeLogEntry = (addChangeLogEntryFormData: AddChangeLogEntryFormData) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsSuccessful(false))
    dispatch(setError(''))

    try {
        const response = await postChangeLogEntryApiCall(addChangeLogEntryFormData)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setChangeLogEntryToExistingChangeLogEntries(response.data))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[addChangeLogEntry]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const editChangeLogEntry = (
    editChangeLogEntryFormData: EditChangeLogEntryFormData,
) => async (dispatch: TypedDispatch, getState: () => Reducers): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsSuccessful(false))
    dispatch(setError(''))

    try {
        const { changeLogEntriesReducer } = getState()
        const response = await patchChangeLogEntryApiCall(editChangeLogEntryFormData)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        const { changeLogEntries } = changeLogEntriesReducer
        const otherChangeLogEntries = changeLogEntries.filter(changeLogEntry => changeLogEntry.id !== response.data.id)
        const newChangeLogEntries = sortChangeLogEntriesByVersionDescending([...otherChangeLogEntries, response.data])

        dispatch(setChangeLogEntries(newChangeLogEntries))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[editChangeLogEntry]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}

export const deleteChangeLogEntry = (changeLogEntryId: string) => async (dispatch: TypedDispatch, getState: () => Reducers): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setIsSuccessful(false))
    dispatch(setError(''))

    try {
        const { changeLogEntriesReducer } = getState()
        const response = await deleteChangeLogEntryApiCall(changeLogEntryId)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        const { changeLogEntries } = changeLogEntriesReducer
        const filteredChangeLogEntries = changeLogEntries.filter(changeLogEntry => changeLogEntry.id !== changeLogEntryId)

        dispatch(setChangeLogEntries(filteredChangeLogEntries))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[deleteChangeLogEntry]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
